import { addEnvSuffix } from 'Utils/env';
import { initializeApp } from 'firebase/app';
import { getRemoteConfig, RemoteConfig } from 'firebase/remote-config';

export type RemoteConfigKey = 'geofences';
export type RemoteConfigValue = RemoteConfig['defaultConfig'][string];

// eslint-disable-next-line prefer-destructuring
const env = process.env;

const FIREBASE_API_KEY = env[addEnvSuffix('FIREBASE_API_KEY')];
const FIREBASE_AUTH_DOMAIN = env[addEnvSuffix('FIREBASE_AUTH_DOMAIN')];
const FIREBASE_PROJECT_ID = env[addEnvSuffix('FIREBASE_PROJECT_ID')];
const FIREBASE_STORAGE_BUCKET = env[addEnvSuffix('FIREBASE_STORAGE_BUCKET')];
const FIREBASE_MESSAGING_SENDER_ID = env[addEnvSuffix('FIREBASE_MESSAGING_SENDER_ID')];
const FIREBASE_APP_ID = env[addEnvSuffix('FIREBASE_APP_ID')];
const FIREBASE_MEASUREMENT_ID = env[addEnvSuffix('FIREBASE_MEASUREMENT_ID')];

const firebaseApp = initializeApp({
  apiKey: FIREBASE_API_KEY,
  appId: FIREBASE_APP_ID,
  authDomain: FIREBASE_AUTH_DOMAIN,
  measurementId: FIREBASE_MEASUREMENT_ID,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
  projectId: FIREBASE_PROJECT_ID,
  storageBucket: FIREBASE_STORAGE_BUCKET,
});

export const firebaseRemoteConfig = getRemoteConfig(firebaseApp);
firebaseRemoteConfig.settings.minimumFetchIntervalMillis = +localStorage.RC_TIME || 15 * 30 * 1000;

const defaultConfig: Record<RemoteConfigKey, RemoteConfigValue> = {
  geofences: false,
};
firebaseRemoteConfig.defaultConfig = defaultConfig;
